import React from "react";
import { useAuth } from "@/App";
import { useLocalDeliveryBooking } from "@/hooks/useLocalDeliveryBooking";
import {
  DeliveryNavbar,
  DeliveryAddressPicker,
  PackageSelector,
  VehicleSelector,
  PaymentMethodSelector,
  PriceSummaryPanel,
  DeliveryConfirmationDialog
} from "@/components/delivery";

export default function LocalDelivery() {
  const { user } = useAuth();
  
  const {
    // Form state
    pickupAddress, setPickupAddress,
    pickupContact, setPickupContact,
    dropAddress, setDropAddress,
    dropContact, setDropContact,
    packageCategory, setPackageCategory,
    packageWeight, setPackageWeight,
    packageDescription, setPackageDescription,
    vehicleType, setVehicleType,
    paymentMethod, setPaymentMethod,
    
    // Coords
    pickupCoords, setPickupCoords,
    dropCoords, setDropCoords,
    gettingLocation,
    getCurrentLocation,
    
    // Phone validation
    setPhonesValid,
    
    // Wallet
    walletBalance, useWallet, setUseWallet,
    walletDeduction, amountToPay,
    
    // Price
    estimatedPrice, estimatedDistance,
    
    // Booking state
    searchingPartner,
    showConfirmation, setShowConfirmation,
    orderData,
    
    // Actions
    handleBookNow,
    resetForm,
    isFormValid
  } = useLocalDeliveryBooking(user);

  return (
    <div className="min-h-screen bg-background">
      <DeliveryNavbar user={user} />

      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="grid lg:grid-cols-5 gap-8">
          {/* Main Booking Form - Left Side */}
          <div className="lg:col-span-3 space-y-6">
            {/* Header */}
            <div className="text-center lg:text-left">
              <h1 className="text-3xl font-black tracking-tight mb-2" data-testid="local-delivery-title">
                Instant Local Delivery
              </h1>
              <p className="text-muted-foreground">
                Book a delivery partner in seconds. Pickup & drop at your doorstep.
              </p>
            </div>

            <DeliveryAddressPicker
              pickupAddress={pickupAddress}
              setPickupAddress={setPickupAddress}
              pickupContact={pickupContact}
              setPickupContact={setPickupContact}
              pickupCoords={pickupCoords}
              setPickupCoords={setPickupCoords}
              dropAddress={dropAddress}
              setDropAddress={setDropAddress}
              dropContact={dropContact}
              setDropContact={setDropContact}
              dropCoords={dropCoords}
              setDropCoords={setDropCoords}
              gettingLocation={gettingLocation}
              onGetCurrentLocation={getCurrentLocation}
              onValidationChange={setPhonesValid}
            />

            <PackageSelector
              packageCategory={packageCategory}
              setPackageCategory={setPackageCategory}
              packageWeight={packageWeight}
              setPackageWeight={setPackageWeight}
              packageDescription={packageDescription}
              setPackageDescription={setPackageDescription}
            />

            <VehicleSelector
              vehicleType={vehicleType}
              setVehicleType={setVehicleType}
            />

            <PaymentMethodSelector
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              walletBalance={walletBalance}
              useWallet={useWallet}
              setUseWallet={setUseWallet}
              estimatedPrice={estimatedPrice}
              user={user}
            />
          </div>

          {/* Price & Book - Right Side */}
          <div className="lg:col-span-2">
            <PriceSummaryPanel
              estimatedPrice={estimatedPrice}
              estimatedDistance={estimatedDistance}
              amountToPay={amountToPay}
              walletDeduction={walletDeduction}
              useWallet={useWallet}
              paymentMethod={paymentMethod}
              vehicleType={vehicleType}
              isFormValid={isFormValid}
              searchingPartner={searchingPartner}
              onBookNow={handleBookNow}
            />
          </div>
        </div>
      </div>

      <DeliveryConfirmationDialog
        open={showConfirmation}
        onOpenChange={setShowConfirmation}
        orderData={orderData}
        pickupAddress={pickupAddress}
        dropAddress={dropAddress}
        onBookAnother={resetForm}
      />
    </div>
  );
}
